
<template>
  <a :href="href" :class="buttonClass" :disabled="isDisabled">
    <icon v-if="icon" :name="icon" :size="iconSize"></icon>
    <span class="button__content" v-html="label" />
  </a>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  components: { Icon },
  name: 'LinkButton',
  props: {
    href: {
      type: String,
      default: '#'
    },
    label: String,
  }
}
</script>

<style scoped lang="scss">
</style>
